import { render, staticRenderFns } from "./otp-message.vue?vue&type=template&id=1bd099d6&"
import script from "./otp-message.vue?vue&type=script&lang=js&"
export * from "./otp-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports